import React,{Component} from 'react';
import "./style.less"
import {NavBar, InputItem, Radio, List, Picker, Toast, Modal, Checkbox } from "antd-mobile";
import cityData from "../../../utils/areaData";
import {invoiceApply,invoiceWeChat,invoiceNameList,getpassengerinfo} from "../../../service/invoiceService";
import {connect} from "react-redux";
let areaVal="";//所在区域
let flag = false;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class InvoiceInfo extends Component{
    constructor(props) {
        super(props);
        console.log(this.props);
        this.state = {
            invoiceType: "dianzi",
            passengerData:'',
            invoiceTit: [
                {value: 0, label: '个人/非企业单位'},
                {value: 1, label: '企业单位'},
            ],
            receiveTypeData:[
                {value: 1, label: '邮寄'},
                {value: 2, label: '自提'},
            ],
            receiveVal:'',
            checkboxData: [
                {value: 1, label: '乘车时间',flag:false},
                {value: 2, label: '身份证号',flag:false},
                {value: 3, label: '出发地目的地',flag:false},
                {value: 4, label: '乘客姓名',flag:false},
            ],
            email:'',
            userPhone:'',
            invoiceVal:0,//发票类型
            invoiceTitVal:0,//抬头类型
            invoiceName:"",//抬头
            invoiceTfe:"",//税号
            addressPhone:'',//地址电话
            addressee:"",//收件人
            recipient:'',
            invoicePhone:"",//联系电话
            invoiceAddress:"",//详细地址
            areaVal:"",
            bankNo:"",//开户行银行账号
            buyerAddress:"", 
			buyerTelphone:"", 
			buyerBankName:"", 
			buyerBankNumber:"", 
            // protocolVal:false,//同意协议、
            // proposerMobile:"",//申请人电话
            // proposerAddress:"",//申请人地址
            passengerList:[
                // {id:1,name:'周杰伦',idnum:'4302********8888',time:'2023-05-06',city:'昆明市-贵州市文山市贵州市文山市贵州市文山市贵州市文山市'},
                // {id:2,name:'周杰伦',idnum:'4302********8888',time:'2023-05-06',city:'昆明市-贵州市文山市'},
                // {id:3,name:'周杰',idnum:'4302********8888',time:'2023-05-06',city:'昆明市-贵州市'},
            ],
            showMore:false,
        }
    }
    componentDidMount() {
        if(flag){
            flag = false;
            this.props.history.goBack()
        }else{
            let params = {
                "source":6,                
                "token":this.props.userInfo.token,
                "data":{
                    "ids":this.props.location.state.invoiceId,
                    "orderType": 1
                   }
            }
            invoiceNameList(params).then((res)=>{
                if (res.data.code === '0000') {
                    let data = [];
                    res.data.data.map((n)=>{
                        data.push({value:n, label:n});
                    });
                    this.setState({passengerData:data})
                }else{
                    Toast.info(res.data.msg,3)
                }
            })
        }
        let params={
            token:this.props.userInfo.token,
            source:6,
            data:{
                ids:this.props.location.state.invoiceId,
                orderType:1,
            },
        };
        getpassengerinfo(params).then((res)=>{
            if (res.data.code === '0000') {
                this.setState({passengerList:res.data.data})
            }else{
                Toast.info(res.data.msg,3)
            }
        })
    }
    //如果选择纸质发票，选择所在区域寄快递的地址
    selectOk(v){
        this.setState({areaVal:v})
    }
    inputChange = key =>(e) =>{
        this.setState({ [key]: e })
    };
    invoiceBtn(){
        const {userPhone,email,invoiceType,invoiceTitVal,invoiceName,invoiceTfe,addressPhone,bankNo,checkboxData,recipient,invoicePhone,invoiceAddress,receiveVal,buyerAddress,buyerTelphone,buyerBankName,buyerBankNumber} = this.state;
        if(invoiceName === ""){
            Toast.info("请填写发票抬头");
            return
        }
        if(invoiceTfe === "" && invoiceTitVal === 1){
            Toast.info("请填写税号");
            return
        }
        if(invoiceTfe === "" && invoiceTitVal === 0){
            Toast.info("请填写身份证号");
            return
        }
        if(invoiceType === 'dianzi' && (email === "" && userPhone === "")){
            Toast.info("请填写电子邮箱或者接收电话");
            return
        }
        if(invoiceType === 'zhizhi' && receiveVal === 1 && recipient === "" ){
            Toast.info("请填写收件人");
            return
        }
        if(invoiceType === 'zhizhi' && receiveVal === 1 && invoicePhone === "" ){
            Toast.info("请填写联系电话");
            return
        }
        if(invoiceType === 'zhizhi' && receiveVal === 1 && areaVal === "" ){
            Toast.info("请选择所在区域");
            return
        }
        if(invoiceType === 'zhizhi' && receiveVal === 1 && invoiceAddress === "" ){
            Toast.info("请填写详细地址");
            return
        }
        let remark= [];
        checkboxData.map((res)=>{
            if(res.flag){remark.push(res.value)}
         });
         Toast.loading("",0);
        let params = {
            token:this.props.userInfo.token,
            source:6,
            data:{
                orderType:1,
                ids:this.props.location.state.invoiceId,//订单id
                invoiceType:invoiceType == 'dianzi' ? 0:1,//电子：0，纸质 ：1
                upType:invoiceTitVal,//抬头类型 个人：0，企业：1
                // invoiceUp:invoiceTitVal == 1 ? invoiceName : invoiceName[0],//发票抬头
                invoiceUp:invoiceName,//发票抬头
                invoiceNumber:invoiceTfe,//发票税号
                // companyPhone:addressPhone,//地址电话
                // bankAccount:bankNo,//开户行账号
                buyerAddress:buyerAddress, 
				buyerTelphone:buyerTelphone, 
				buyerBankName:buyerBankName, 
				buyerBankNumber:buyerBankNumber,

                invoiceContent:'*运输服务*客运服务费',//发票内容
                invoiceAmount:this.props.location.state.invoicePic,//发票金额
                notes:remark,//发票备注
                recipient:recipient,//收件人
                contactPhone:invoicePhone.replace(/\s/ig, ''),//联系电话
                contactAddress:areaVal + invoiceAddress,//收件详细地址
                moneySource:6,
                email:email,
                receiveType:receiveVal,
                userPhone:userPhone,
                isBwy:this.props.location.state.isBwy,
                invoiceSign:this.props.location.state.invoiceSign, 
            },
        };
        Toast.loading("正在加载");
        console.log(params);
        invoiceApply(params).then((res)=>{
            Toast.hide();
            console.log(res);
            if(res.data.code === "0000"){
                if(this.state.invoiceType === 'zhizhi' && receiveVal === 1){
                    Toast.hide();
                    // console.log(res.data.data);
                    //如果为纸质发票且为邮寄需要调用支付
                    document.location = `js://webview?invoiceNo=${res.data.data}&token=${this.props.userInfo.token}`;
                }else{
                    this.props.history.push('/invoiceSucceed');
                    flag = true;
                }
            }else{
                Toast.info(res.data.msg);
            }
        }).catch(function (error) {
            Toast.hide();
            console.log(error);
        });
    }
    getArea(labels){
        areaVal = '';
        labels.map((res)=>{
            areaVal += res
        });
        return labels.join(',');
    }
    // protocolChange =(e)=>{
    //     this.setState({protocolVal:e.target.checked});
    //     console.log(e.target.checked);
    // };
    addActive(v, key){
        this.setState({[key]: v,})
    };
    checkChange(e,res){
        res.flag = e.target.checked;
    }
    render(){
        const {showMore,passengerList,passengerData,bankNo,recipient,addressPhone,invoiceType,invoiceTit,invoiceTitVal,invoiceName,invoiceTfe,invoicePhone,invoiceAddress,areaVal,email,receiveVal,receiveTypeData,userPhone,buyerAddress,buyerTelphone,buyerBankName,buyerBankNumber} = this.state;
        return(
            <div className="invoiceInfo">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}/>}
                >开具发票</NavBar>

                <div className="warp">
                    <div className="con">
                        <div className="tit">请选择发票类型</div>
                        <div className="info">
                            <div className="invoiceType">
                                <span className={invoiceType === "dianzi" ? 'activity dianzi' : 'dianzi'} onClick={()=>this.setState({invoiceType :'dianzi'})}>电子发票<i>3~5天开具</i></span>
                                <span className={invoiceType === "zhizhi" ? 'activity' : ''}  onClick={()=>this.setState({invoiceType :'zhizhi'})}>纸质发票<i>3~5天开具</i></span>
                                <p>使用电子发票与纸质发票具有同等法律效力，可支持报销入账。</p>
                                {/*{invoiceType.map((res, i) => (
                                <Radio className="my-radio" key={i} checked={invoiceVal === res.value}
                                       onChange={() => this.setState({invoiceVal: res.value})}>
                                    {res.label}
                                </Radio>
                            ))}*/}
                            </div>
                            <div className="tit">发票详情</div>
                            <List.Item>
                                抬头类型
                                {invoiceTit.map((res, i) => (
                                    <Radio className="my-radio" key={i} checked={invoiceTitVal === res.value}
                                           onChange={() => this.setState({invoiceTitVal: res.value,invoiceName:"",invoiceTfe:""})}>
                                        {res.label}
                                    </Radio>
                                ))}
                            </List.Item>
                            <InputItem
                                        className="inp"
                                        placeholder="填写发票抬头"
                                        value={invoiceName}
                                        onChange={this.inputChange("invoiceName")}
                                    ><span style={{color:'red'}}>*</span>发票抬头</InputItem>
                            {/* 发票类型改为输入框 */}
                            {/* {
                                this.state.invoiceTitVal === 1 ?
                                    <InputItem
                                        className="inp"
                                        placeholder="填写发票抬头"
                                        value={invoiceName}
                                        onChange={this.inputChange("invoiceName")}
                                    ><span style={{color:'red'}}>*</span>发票抬头</InputItem>
                                : <Picker
                                    cols={1}
                                    data={passengerData}
                                    value={invoiceName}
                                    onOk={(v) =>this.addActive(v, 'invoiceName')}

                                 >
                                    <List.Item arrow="horizontal" className="selPas"><span style={{color:'red'}}>*</span>发票抬头</List.Item>
                                </Picker>
                            } */}
                            {/* <InputItem
                                className="inp"
                                placeholder={this.state.invoiceTitVal === 0 ? '请填写身份证号' :'填写纳税人识别号'}
                                value={invoiceTfe}
                                onChange={this.inputChange("invoiceTfe")}
                            >{this.state.invoiceTitVal === 1 ? <span><span style={{color:'red'}}>*</span>税号</span> : <span><span style={{color:'red'}}>*</span>身份证号</span>}</InputItem> */}
                            {
                                this.state.invoiceTitVal === 1 ?
                                    <InputItem
                                        className="inp"
                                        placeholder="填写纳税人识别号"
                                        value={invoiceTfe}
                                        onChange={this.inputChange("invoiceTfe")}
                                    ><span style={{color:'red'}}>*</span>税号</InputItem> :
                                    <InputItem
                                        className="inp"
                                        placeholder="填写身份证号"
                                        value={invoiceTfe}
                                        onChange={this.inputChange("invoiceTfe")}
                                    ><span style={{color:'red'}}>*</span>身份证号</InputItem>
                            }
                            {
                                this.state.invoiceTitVal === 1&&
                                <InputItem
                                className="inp"
                                placeholder="填写公司地址"
                                value={buyerAddress}
                                onChange={this.inputChange("buyerAddress")}
                            >公司地址</InputItem>}
                           { 
                           this.state.invoiceTitVal === 1&&
                           <InputItem
                                className="inp"
                                placeholder="填写公司电话"
                                value={buyerTelphone}
                                onChange={this.inputChange("buyerTelphone")}
                            >公司电话</InputItem>}
                           { 
                             this.state.invoiceTitVal === 1&&
                                <InputItem
                                    className="inp"
                                    placeholder="开户行"
                                    value={buyerBankName}
                                    onChange={this.inputChange("buyerBankName")}
                                >开户行</InputItem>}
                            { 
                                this.state.invoiceTitVal === 1&&
                                <InputItem
                                    className="inp"
                                    placeholder="填写卡号"
                                    value={buyerBankNumber}
                                    onChange={this.inputChange("buyerBankNumber")}
                                >卡号</InputItem>}

                            <List.Item  extra={"*运输服务*客运服务费"}>发票内容</List.Item>
                            <List.Item className="invociePic" extra={'￥' + this.props.location.state.invoicePic}>发票金额</List.Item>

                            {/* <List.Item>
                                <span>备注信息：</span>
                                <div className="checkbox">
                                    {this.state.checkboxData.map((res, i) => (
                                        <Checkbox className="my-checkbox" key={i}
                                                onChange={(e) => this.checkChange(e,res)}
                                        >
                                            &nbsp;{res.label}
                                        </Checkbox>
                                    ))}
                                </div>
                            </List.Item> */}
                            <div className="con">
                                <div className="tit">乘客信息<div className='red red1'>*如需修改出行人员信息的可联系客服，修改完成后再行申请</div></div>
                                {passengerList.length > 0 ?
                                <div className={showMore ? "passengertextbox" :"passengertextbox passengertextboxHidden"} >
                                    {passengerList.map((res)=>(
                                        <div className='passengertext'>
                                            <i className="icon iconfont iconpeople"/>
                                            <span className=''>{res.carriageName}</span>
                                            <span className=''>{res.carriageIdNo.substr(0, 4)+ '*******' +res.carriageIdNo.substr(14)}</span>
                                            <span className=''>{res.carriageDateYmd}</span>
                                            <span className=''>{res.carriageLeave+'-'+res.carriageArrive}</span>
                                        </div>
                                    ))}
                                </div>:null}
                                {
                                    passengerList.length > 2 ? <div className='more'>
                                    {showMore?
                                    <i className="icon iconfont iconzhankai1" onClick={()=>{this.setState({showMore:false})}}/>:
                                    <i className="icon iconfont iconshouqi" onClick={()=>{this.setState({showMore:true})}}/>}
                                </div>:null
                                }
                            </div>
                            {
                                invoiceType === 'dianzi' ? 
                                <div className="con">
                                    <div className="tit">接收方式</div>
                                    <InputItem
                                        className="inp"
                                        placeholder="请填写电子邮箱"
                                        value={email}
                                        onChange={this.inputChange("email")}
                                    >电子邮箱</InputItem>
                                    <InputItem
                                        className="inp"
                                        placeholder="请填写接收电话"
                                        value={userPhone}
                                        onChange={this.inputChange("userPhone")}
                                    >接收电话</InputItem>
                                </div> :    
                                <div className="con">
                                    <div className="tit">接收方式</div>
                                    <List.Item>
                                        接收方式
                                        {receiveTypeData.map((res, i) => (
                                            <Radio className="my-radio" key={i} checked={receiveVal === res.value}
                                                onChange={() => this.setState({receiveVal: res.value})}>
                                                {res.label}
                                            </Radio>
                                        ))}
                                    </List.Item>
                                </div>
                            }
                         
                           
                        </div>
                    </div>
                   
                    {
                        invoiceType === 'zhizhi' && receiveVal === 1 ?  (
                            <div className="con">
                               
                                <div className="info">
                                    <InputItem
                                        className="inp"
                                        placeholder="请填写收件人"
                                        value={recipient}
                                        onChange={this.inputChange("recipient")}
                                    >收件人</InputItem>
                                    <InputItem
                                        type="phone"
                                        className="inp"
                                        placeholder="请填写联系电话"
                                        value={invoicePhone}
                                        onChange={this.inputChange("invoicePhone")}
                                    >联系电话</InputItem>
                                    <Picker
                                        title="选择地区"
                                        extra="请选择所在区域"
                                        data={cityData}
                                        value={areaVal}
                                        format={(labels) => this.getArea(labels)}
                                        onOk={v => this.selectOk(v)}
                                    >
                                        <List.Item arrow="horizontal" >所在区域</List.Item>
                                    </Picker>
                                    <InputItem
                                        className="inp address"
                                        placeholder="请填写详细地址"
                                        value={invoiceAddress}
                                        onChange={this.inputChange("invoiceAddress")}
                                    >详细地址</InputItem>
                                    <div className="text">* 纸质发票申请将收取发票邮寄费用10元/次</div>
                                </div>
                            </div> 
                        ): null
                    }
                    {/*<div className="protocol">
                        <CheckboxItem  onChange={(e) => this.protocolChange(e)}>
                            <div onClick={() => this.props.history.push('/invoiceProtocol')}>我同意开具发票协议</div>
                        </CheckboxItem>
                    </div>*/}
                    <button onClick={()=>this.invoiceBtn()}>提交</button>
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Invoice/InvoiceInfo/index.js